let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fm1Fn")).then(() => parcelRequire('5s8Hd'));